module.exports = __webpack_public_path__ + "static/media/2.d0f835f1.jpg";